import React from "react";

function Footer() {
  return (
    <container>
      <section className="xs:flex-row md:flex bg-[#141833] xs:px-12 xs:py-20 lg:px-36 lg:py-32 border-t border-[#EDB6A2]">
        <article className="md:w-full lg:w-1/5">
          <a href="/">
            <img alt="logo" className="xs:w-[120px] xs:m-auto md:m-0 md:w-[220px] max-w-none" src="../images/footer-logo.png"></img>
          </a>
        </article>
        <article className="md:w-full lg:w-4/5 xs:text-center md:text-right text-[#EDB6A2] xs:pt-10 md:pt-0">
          <img className="inline" alt="logo" src="../images/insta-logo.png"></img>
          <p className="pt-10 text-2x1 font-gothLight">+44 (0) 1279 881605</p>
          <p className="text-2x1 font-gothLight">hello@chaldean-prime.co.uk</p>
          <p className="pt-10 text-2x1 font-gothLight">
            Website created by
            <a href="https://shakastudio.co.uk/" className="hover:underline">
              {" "}
              Shaka Studio
            </a>
            <sup>
              <svg className="inline-block ml-1" xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 20.423 15.317">
                <path
                  id="Path_4138"
                  data-name="Path 4138"
                  d="M16.536,7.659H10.522a.311.311,0,0,1-.311-.311V5.417a.311.311,0,0,1,.311-.311h6.071A1.277,1.277,0,0,1,17.87,6.382c0,.018,0,.035,0,.052h2.555a3.83,3.83,0,0,0-3.829-3.881H10.522a.311.311,0,0,1-.311-.311V.358A.358.358,0,0,0,9.853,0H3.886a3.83,3.83,0,1,0-.057,7.659H9.9a.311.311,0,0,1,.311.311V9.844c0,.332-.368.368-.368.368H3.829A1.277,1.277,0,0,1,2.552,8.935c0-.018,0-.035,0-.052H0a3.83,3.83,0,0,0,3.829,3.881H9.9a.311.311,0,0,1,.311.311v1.93a.311.311,0,0,0,.311.311h6.071a3.83,3.83,0,1,0-.057-7.659ZM3.829,5.106A1.277,1.277,0,0,1,2.553,3.783,1.3,1.3,0,0,1,3.86,2.553H9.9a.311.311,0,0,1,.311.311V5.106Zm12.734,7.659h-6.04a.311.311,0,0,1-.311-.311v-1.93a.311.311,0,0,1,.311-.311h6.071a1.277,1.277,0,0,1,1.276,1.323A1.3,1.3,0,0,1,16.563,12.764Z"
                  transform="translate(0)"
                  fill="#edb6a2"
                />
              </svg>
            </sup>
          </p>
        </article>
      </section>
    </container>
  );
}

export default Footer;
